var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box",style:({ padding: _vm.pd10 })},[_c('recom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }